import * as types from '../types/textEditors'

export const addTextEditor = payload => ( {
  type: types.ADD_TEXT_EDITOR,
  payload: payload
} )

export const setActiveTextEditor = payload => ( {
  type: types.SET_ACTIVE_EDITOR,
  payload: payload
} )

export const updateEditorState = payload => ( {
  type: types.UPDATE_TEXT_EDITOR,
  payload: payload
} )


// WEBPACK FOOTER //
// ./src/store/actions/textEditors.js